module.exports = __webpack_public_path__ + "img/eight.551b6717.jpg";